import { teamListQuerySchema } from '@sahab/contracts'
import { z } from 'zod'

export const teamViewSchema = teamListQuerySchema.shape.view.unwrap()
export type TeamView = z.infer<typeof teamViewSchema>

/** The list's view tabs, in order (Active, the default, is never written to the URL). */
export const TEAM_VIEWS: readonly TeamView[] = ['active', 'mine', 'archived']

export const TEAM_PAGE_SIZE = 50

/** The teams list in the URL: view, search and page. Invalid values fall back to the defaults. */
export const teamsSearchSchema = z.object({
  view: teamViewSchema.optional().catch(undefined),
  q: z.coerce.string().trim().max(200).optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
})
export type TeamsSearch = z.infer<typeof teamsSearchSchema>

export interface TeamListParams {
  view: TeamView
  q: string | undefined
  page: number
  pageSize: number
}

export function toTeamListQuery(search: TeamsSearch): TeamListParams {
  return {
    view: search.view ?? 'active',
    q: search.q || undefined,
    page: search.page ?? 1,
    pageSize: TEAM_PAGE_SIZE,
  }
}
